// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-screen {
  margin: 1.5rem 0;
  display: flex;
  justify-content: space-between;
}
.settings-screen form {
  margin-bottom: 0 !important;
}
@media (max-width: 768px) {
  .settings-screen {
    margin-top: 1rem;
    margin-bottom: 1rem;
    flex-direction: column;
  }
}
.settings-sidebar-wrapper {
  width: 20%;
  padding-right: 1.5rem;
  border-right: 1px solid var(--black1);
}
@media (max-width: 768px) {
  .settings-sidebar-wrapper {
    display: none;
  }
}
.settings-content-wrapper {
  width: calc(80% - 1.5rem);
}
@media (max-width: 768px) {
  .settings-content-wrapper {
    width: 100%;
  }
}

.app {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/settings/index.scss"],"names":[],"mappings":"AAEE;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;AADJ;AAGI;EACE,2BAAA;AADN;AAII;EATF;IAUI,gBAAA;IACA,mBAAA;IACA,sBAAA;EADJ;AACF;AAIE;EACE,UAAA;EACA,qBAAA;EACA,qCAAA;AAFJ;AAII;EALF;IAMI,aAAA;EADJ;AACF;AAIE;EACE,yBAAA;AAFJ;AAII;EAHF;IAII,WAAA;EADJ;AACF;;AAMA;EACE,WAAA;AAHF","sourcesContent":[".settings {\n\n  &-screen {\n    margin: 1.5rem 0;\n    display: flex;\n    justify-content: space-between;\n\n    form {\n      margin-bottom: 0 !important;\n    }\n\n    @media (max-width: 768px) {\n      margin-top: 1rem;\n      margin-bottom: 1rem;\n      flex-direction: column;\n    }\n  }\n\n  &-sidebar-wrapper {\n    width: calc(20%);\n    padding-right: 1.5rem;\n    border-right: 1px solid var(--black1);\n\n    @media (max-width: 768px) {\n      display: none;\n    }\n  }\n\n  &-content-wrapper {\n    width: calc(80% - 1.5rem);\n\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n\n}\n\n.app {\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
